import { createFileRoute, useRouterState } from '@tanstack/react-router';
import { Hammer } from 'lucide-react';
import { Page, PageHeader } from '../../ui/Page.jsx';
import { Card } from '../../ui/Card.jsx';
import { EmptyState } from '../../ui/States.jsx';
import { NotFound } from '../../components/NotFound.jsx';
import { navItemFor } from '../../config/navigation.js';

/**
 * A section that is in the navigation but not wired to the backend yet says so plainly — it never
 * shows sample data. Anything that is not a section at all is a real 404.
 */
export const Route = createFileRoute('/_app/$')({ component: NotBuiltYet });

function NotBuiltYet() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const item = navItemFor(pathname);
  if (!item || pathname !== item.to) return <NotFound />;
  return (
    <Page>
      <PageHeader title={item.label} />
      <Card>
        <EmptyState icon={Hammer} title={`${item.label} is being connected`} body="This section isn’t wired to live data yet, so nothing is shown rather than sample figures." />
      </Card>
    </Page>
  );
}
